<template>
  <div
    v-if="isVisible"
    class="js-menu-trigger-wrap cursor-pointer"
    @click="onMenuClick">
    <slot />
  </div>
</template>

<script lang="ts">
import {
  useGlobalMenuStore,
  type GlobalMenuWidth,
  type GlobalMenuPlacement,
} from '@/stores/globalMenuStore'

export default {
  name: 'MenuTriggerWrap',
  props: {
    menuName: {
      type: String,
      required: true,
    },
    // Whether the trigger itself should render at all. Defaults to true for
    // menus with no permission-gated items. For a menu whose items are gated
    // by canUser(...), pass a computed here that mirrors the same check(s) —
    // see .claude/instructions/permission-visibility.md.
    isVisible: {
      type: Boolean,
      default: true,
    },
    width: {
      type: String as () => GlobalMenuWidth,
      default: 'md',
    },
    menuProps: {
      type: Object as () => Record<string, unknown>,
      default: () => ({}),
    },
    placement: {
      type: String as () => GlobalMenuPlacement,
      default: 'auto',
    },
  },
  methods: {
    onMenuClick() {
      const globalMenu = useGlobalMenuStore()
      globalMenu.open({
        name: this.menuName,
        triggerElement: this.$el,
        width: this.width,
        props: this.menuProps,
        placement: this.placement,
      })
    },
  },
}
</script>

